import React, { Component } from 'react'

// redux
import Button from '../../components/uielements/button'
import { connect } from 'react-redux'
import mediaActions from '../../redux/qbmedia/actions'
import { Form, Input, Switch, Upload, Icon, message, Tooltip, Avatar, Col, Modal } from 'antd'
import { FaTimes, FaPlus, FaSave } from 'react-icons/fa'
import defaultImgEvent from '../../resource/image/imgEventDefaul.jpg'
import objectDefault from '../../resource/image/objectDefault.png'
import scrumBoardActions from '../../redux/scrumBoard/actions'
import { getRelateMediaApi } from '../../services/apis/QBMediaAPIServices'
import SelectObjectComponent from '../../components/select_objects'
import SelectEventComponent from '../../components/select_events'
// import Docxtemplater from "docxtemplater";
// import JSZip from "jszip";

const { TextArea } = Input

class MediaInfoForm extends Component {
    state = {
        file: null,
        fileList: [],
    }

    // helper
    equalArray = (arr1, arr2) => {
        if (!Array.isArray(arr1) || !Array.isArray(arr2)) return false
        if (arr1.length !== arr2.length) return false
        for (let index = 0; index < arr1.length; index++)
            if (arr1[index] !== arr2[index]) return false

        return true
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1
    }

    // update new props
    componentWillReceiveProps(nextProps) {
        if (nextProps.media !== this.props.media) {
            const { form, media } = nextProps

            this.setState({
                countId: media.hashtag.length,
            })

            form.setFieldsValue({
                tags: [],
                names: [],
            })

            const tags = media.hashtag
            for (let index = 0; index < tags.length; index++) {
                const keys = form.getFieldValue('tags')
                const nextKeys = keys.concat(index)
                form.setFieldsValue({
                    tags: nextKeys,
                })
            }

            form.setFieldsValue({
                names: tags,
            })
        }
    }
    componentWillUnmount() {
        this.props.applyToCurrentObject([])
        this.props.updateListCurrentEvent([])
    }

    async componentDidMount() {
        const { form, media } = this.props
        console.log("mediamediamedia", media)
        if (media && media.hashtag) {
            if (media && media.media_id) {
                let reqRelate = await getRelateMediaApi(media.media_id)
                if (reqRelate && reqRelate.error.code === 200) {
                    this.props.applyToCurrentObject(reqRelate.obj_ext)
                    this.props.updateListCurrentEvent(reqRelate.event_ext)
                }
            }
            this.setState({
                countId: media.hashtag.length,
            })

            form.setFieldsValue({
                tags: [],
                names: [],
            })

            if (media.media_id !== 0) this.setState({ fileList: [] })

            const tags = media.hashtag
            for (let index = 0; index < tags.length; index++) {
                const keys = form.getFieldValue('tags')
                const nextKeys = keys.concat(index)
                form.setFieldsValue({
                    tags: nextKeys,
                })
            }

            form.setFieldsValue({
                names: tags,
            })
        }
    }

    // event
    onSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (
                    this.state.fileList.length === 0 &&
                    this.props.media.media_id === 0
                ) {
                    message.error('Bạn phải lựa chọn file upload')
                    return
                }

                if (this.state.fileList[0]) {
                    const { name } = this.state.fileList[0]
                    this.props.updateCurrentMedia({ name })
                }

                this._handleUpdateCurrentTag()

                this.props.saveCurrentMedia()
                this.props.dismiss()

                this.setState({ fileList: [] })
            }
        })
    }
    componentWillUnmount() {
        this.props.applyToCurrentObject([])
        this.props.updateListCurrentEvent([])
    }

    // handle
    _handleUpdateCurrentTag = () => {
        console.log('start')
        try {
            const { form } = this.props
            const names = form.getFieldValue('names')
            const keys = form.getFieldValue('tags')
            if (!names) {
                this.props.updateCurrentMedia({ hashtag: [] })
                return
            }
            console.log('step 1')

            if (names.length < keys.length) return

            console.log('step 2')

            const nextNames = names.filter((tag, index) => {
                if (!this.isInArray(index, keys)) {
                    return false
                }
                if (typeof tag === undefined) return false
                if (tag === '') return false
                return true
            })

            console.log('step 3')

            console.log('next names : ', nextNames)
            if (this.equalArray(this.props.media.hashtag, nextNames) === false)
                this.props.updateCurrentMedia({ hashtag: nextNames })
        } catch { }
    }

    _handleAddTag = () => {
        const { form } = this.props
        const keys = form.getFieldValue('tags')
        const nextKeys = keys.concat(this.state.countId)
        form.setFieldsValue({
            tags: nextKeys,
        })

        this.setState({ countId: this.state.countId + 1 })
    }

    _handleDelete = id => {
        const { form } = this.props
        const keys = form.getFieldValue('tags')
        const namesData = form.getFieldValue('names')
        const nextName = namesData.filter((item, index) => {
            return index != id
        })
        const nextKeys = keys.filter(key => key !== id)
        form.setFieldsValue({
            tags: nextKeys,
        })
        this.props.updateCurrentMedia({ hashtag: nextName })

    }

    _handleChangeFileUpload = info => {
        // console.log('file list', info)
        // let fileReader;
        // fileReader = new FileReader();
        // fileReader.readAsBinaryString(info.file.originFileObj);
        // fileReader.onload = async (e) => {
        //     const content = e.target.result;
        //     var doc = new Docxtemplater(new JSZip(content), {
        //         delimiters: {
        //             start: '12op1j2po1j2poj1po',
        //             end: 'op21j4po21jp4oj1op24j'
        //         }
        //     });
        //     var text = doc.getFullText();
        //     console.log(text)
        // };

        if (info.file.status === 'done') {
            this.props.updateFile(info.file.originFileObj)
        }

        let fileList = [...info.fileList]

        fileList = fileList.slice(-1)

        // 2. Read from response and show file link
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                const url = file.response
                if (url[0] === 'h' && url[1] === 't') file.url = file.response
            }
            return file
        })


        let index = this.state.fileList.findIndex(vl => {
            return vl.name === fileList[0].name
        })
        if (index === -1) {
            let dataFileList = this.state.fileList.concat(fileList)
            this.setState({ fileList: dataFileList })

        }

    }

    customRequest = ({ file, onSuccess, onError }) => {
        console.log('custom request', file)
        onSuccess('ok')
        setTimeout(() => {
            // uploadMediaFile(file).then(response => {
            //     console.log("response : ", response)
            //     const avatar = response.uploaded_files[0]
            //     console.log(avatar)

            //     if (avatar[0] !== 'h' || avatar[1] !== 't')
            //         onError(avatar)

            //     onSuccess(avatar)
            // })
            // .catch(error => onError(error))

            if (file.size > 400000000)
                onError('Kích thước tối đa là 400 MB', file)
            onSuccess('ok', file)
        }, 0)
    }
    _userSelectObject = objects => {
        this.props.showModalObject(false)
        this.props.applyToCurrentObject([])
        this.props.applyToCurrentObject(objects)
    }
    _userSelectEvent = events => {
        this.props.visibleModalEvent(false)
        this.props.updateListCurrentEvent([])
        this.props.updateListCurrentEvent(events)
    }

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form
        const { media } = this.props

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        }
        const formItemLayoutWithOutLabel = {
            wrapperCol: {
                xs: { span: 24, offset: 24 },
                sm: { span: 16, offset: 8 },
            },
        }

        getFieldDecorator(`tags`, { initialValue: [] })
        const tags = getFieldValue('tags')
        const formItems = Array.isArray(tags)
            ? tags.map((k, index) => (
                <Form.Item
                    {...(index === 0
                        ? formItemLayout
                        : formItemLayoutWithOutLabel)}
                    label={index === 0 ? 'Thẻ' : ''}
                    required={false}
                    key={k}
                >
                    {getFieldDecorator(`names[${k}]`, {
                        validateTrigger: ['onChange', 'onBlur'],
                        rules: [
                            {
                                required: true,
                                whitespace: true,
                                message: 'Xin mời nhập nội dung thẻ',
                            },
                        ],
                        initialValue: media.hashtag[index]
                            ? media.hashtag[index]
                            : '',
                    })(
                        <TextArea
                            autosize
                            placeholder="Tên thẻ"
                            style={{
                                width: '60%',
                                marginRight: 8,
                                marginBottom: 3,
                                marginTop: 3,
                            }}
                        />
                    )}
                    <FaTimes onClick={() => this._handleDelete(k)} />
                </Form.Item>
            ))
            : null

        let buttonUpload = (
            <Button style={{ border: '1px solid' }}>
                <Icon type="upload" /> Click to Upload
            </Button>
        )

        const uploadFile = (
            <Form.Item label={this.state.fileList.length > 0 ? "" : "File"} >
                <Upload
                    name="file"
                    showUploadList={false}
                    multiple={true}
                    customRequest={this.customRequest}
                    onChange={this._handleChangeFileUpload}
                    fileList={this.state.fileList}
                >
                    {this.state.fileList.length > 0 ? null : buttonUpload}
                </Upload>
            </Form.Item>
        )

        const filename = <Form.Item label="File">{media.name}</Form.Item>

        return (
            <Form {...formItemLayout} onSubmit={this.onSubmit}>
                {media.media_id === 0 ? uploadFile : filename}
                {this.state.fileList.length > 0 && this.state.fileList.map(file => (
                    <Form.Item label="File">{file.name}</Form.Item>
                ))}
                {formItems}
                {/* <Form.Item label="Sự kiện liên quan" hasFeedback>
                    <Col>
                        {this.props.ListCurrentEvent.map(event => (
                            <Tooltip
                                title={event.name}
                                placement="bottom"
                                key={event}
                            >
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`/app/qbevents/${event.event_id}`}
                                >
                                    <Avatar
                                        shape="square"
                                        size={64}
                                        src={
                                            event.avatar === ''
                                                ? defaultImgEvent
                                                : event.avatar
                                        }
                                        style={{
                                            margin: 10,
                                        }}
                                    />
                                </a>
                            </Tooltip>
                        ))}
                        <Button
                            type="primary"
                            icon="upload"
                            onClick={() => this.props.visibleModalEvent(true)}
                            style={{
                                marginTop: 10,
                                width: 170,
                                justifyContent: 'center',
                                marginLeft: 20,

                            }}
                        >
                            Chọn sự kiện
                        </Button>
                    </Col>
                </Form.Item> */}
                {/* <Form.Item label="Đối tượng liên quan" hasFeedback>
                    <Col>

                        {this.props.ListCurrentObject.map(object => (
                            <Tooltip
                                title={object.name}
                                placement="bottom"
                                key={object}
                            >
                                <Avatar
                                    shape="square"
                                    size={64}
                                    src={
                                        object.avatar === ''
                                            ? objectDefault
                                            : object.avatar
                                    }
                                    style={{ margin: 10 }}
                                />
                            </Tooltip>
                        ))}
                        <Button
                            type="primary"
                            icon="upload"
                            onClick={() => this.props.showModalObject(true)}
                            style={{
                                marginTop: 10,
                                width: 170,
                                justifyContent: 'center',
                                marginLeft: 20,

                            }}
                        >
                            Chọn đối tượng
                        </Button>
                    </Col>
                </Form.Item> */}
                <Form.Item {...formItemLayoutWithOutLabel}>
                    <Button
                        onClick={() => this._handleAddTag()}
                        style={{
                            width: '60%',
                            border: '1px solid blue',
                            color: 'blue',
                            marginBottom: 20,
                        }}
                    >
                        <FaPlus style={{ marginRight: 5 }} /> Thêm thẻ
                    </Button>
                </Form.Item>
                <Form.Item wrapperCol={{ span: 15, offset: 11 }}>
                    <Button
                        size="large"
                        htmlType="submit"
                        style={{
                            backgroundColor: 'lightgreen',
                            marginRight: 5,
                            color: 'black',
                        }}
                    >
                        <FaSave style={{ marginRight: 5 }} />
                        Lưu
                    </Button>

                    <Button
                        size="large"
                        onClick={() => {
                            this.setState({ fileList: [] })
                            this.props.onCancel()
                        }}
                        style={{ backgroundColor: ' #ffcccc', color: 'black' }}
                    >
                        <FaTimes style={{ marginRight: 5 }} />
                        Huỷ
                    </Button>
                </Form.Item>
                {this.props.VisibleModalEvent && (
                    <Modal
                        visible={true}
                        title="Sự kiện liên quan"
                        onOk={() => this.props.visibleModalEvent(false)}
                        onCancel={() => this.props.visibleModalEvent(false)}
                        width={900}
                        centered
                        footer={[]}
                    >
                        <SelectEventComponent
                            onSuccess={events => this._userSelectEvent(events)}
                            onCancel={() => this.props.visibleModalEvent(false)}
                            initEvent={this.props.ListCurrentEvent}
                        />
                    </Modal>
                )}
                {this.props.VisibleModalObject && (
                    <Modal
                        visible={true}
                        title="Lựa chọn đối tượng"
                        onOk={() => this.props.showModalObject(false)}
                        onCancel={() => this.props.showModalObject(false)}
                        width={900}
                        centered
                        footer={[]}
                    >
                        <SelectObjectComponent
                            onSuccess={objects =>
                                this._userSelectObject(objects)
                            }
                            onCancel={() => this.props.showModalObject(false)}
                            initObject={this.props.ListCurrentObject}
                        />
                    </Modal>
                )}
            </Form>
        )
    }
}

const WrappedMediaInfoForm = Form.create({ name: 'mediaInfo' })(MediaInfoForm)

const mapStateToProps = state => {
    console.log('---  state --- ', state)
    return {
        media: state.qbmedia.currentMedia,
        ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
        ListCurrentObject: state.scrumBoard.ListCurrentObject,
        VisibleModalEvent: state.scrumBoard.VisibleModalEvent,
        VisibleModalObject: state.scrumBoard.VisibleModalObject,

    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateCurrentMedia: media => {
            dispatch(mediaActions.action.updateCurrentMedia(media))
        },
        updateFile: file => {
            dispatch(mediaActions.action.updateFile(file))
        },
        saveCurrentMedia: () => {
            dispatch(mediaActions.action.saveCurrentMedia())
        },
        dismiss: () => {
            dispatch(mediaActions.action.dismissModalCurrentMediaInfo())
        },
        applyToCurrentObject: data => {
            dispatch(scrumBoardActions.applyToCurrentObject(data))
        },
        updateListCurrentEvent: data => {
            dispatch(scrumBoardActions.updateListCurrentEvent(data))
        },
        showModalObject: visible => {
            dispatch(scrumBoardActions.showModalObject(visible))
        },
        visibleModalEvent: visible => {
            dispatch(scrumBoardActions.visibleModalEvent(visible))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WrappedMediaInfoForm)
